export const config = {
    session_id: "session",
    token_id: "auth"
};